import React, { useEffect, useState } from "react"
import { Box, FormGroup, FormControlLabel, Switch } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import { showDuplicateAction } from "../../../actions/filterActions"
import { useDispatch, useSelector } from "react-redux"
import { resetSelectedIdsAction } from "../../../actions/downloadsActions"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiFormControlLabel-label": {
			fontSize: theme.typography.fontSize,
			fontWeight: theme.typography.fontWeightRegular,
		},
	},
}))

const BlueSwitch = withStyles((theme) => ({
	switchBase: {
		color: theme.palette.common.white,
		"&$checked": {
			color: theme.palette.primary.dark,
		},
		"&$checked + $track": {
			backgroundColor: theme.palette.primary.dark,
		},
	},
	checked: {},
	track: {},
}))(Switch)

export default function ShowDuplicateSwitch() {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles(theme)
	const dispatch = useDispatch()
	const { showDuplicate } = useSelector((state) => state.filter)

	const handleChange = (event) => {
		dispatch(resetSelectedIdsAction())
		dispatch(showDuplicateAction({ data: event.target.checked ? false : true }))
	}

	return (
		<Box mr={2}>
			<FormGroup row className={classes.root}>
				<FormControlLabel
					control={<BlueSwitch checked={!showDuplicate} onChange={handleChange} name="showDuplicate" />}
					label={t("showDuplicate")}
					labelPlacement="start"
				/>
			</FormGroup>
		</Box>
	)
}
